// Stub for Node.js 'fs' module — required by openscad-parser's CodeFile
// but never actually called in our browser usage (we only use the constructor).
export const readFile = () => {
  throw new Error('fs.readFile is not available in the browser');
};

export default { readFile };
